import "../../css/GameRoom.css"
import { useNavigate } from "react-router-dom";

const GameCard = ({game}) =>{
    const navigate = useNavigate();

    const handleCardClick = () =>{
        navigate("/gameroom?gameId=" + game.userId + "_" + game.gameId);
    }

    return(
        <div className="game-card" onClick={()=>handleCardClick()}>
            <div style={{position:"absolute", display:"flex", width:"100%", height:"35px", top:"10%", justifyContent:"center", alignItems:"center"}}>
                <div style={{textAlign:"center", overflowWrap:"break-word", lineHeight:"14px", width:"70%", fontSize:"14px"}}>{game.gameName}</div>
            </div>
            <img className="game-card-bg" src="/assets/games/gameroom/cards/jumper_card.png" />
            <img className="game-card-icon" src={game.gameDesign.gameicon}/>

            <div style={{position:"absolute", width:"40%", height:"35px", top:"78%", left:"22px", display:"flex", alignItems:"center"}}>
                <div style={{width:"100%", textAlign:"left", fontSize:"12px", overflowWrap:"break-word", lineHeight:"12px", fontWeight:"600"}}>
                    {game.userName}
                </div>    
            </div>

        </div>
    )
}

export default GameCard;